import * as React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export const NavigateToIcon = (props: Props) => {
  return (
    <svg
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      focusable='false'
      {...props}
    >
      <path d='M8.47728 10.0371H0.765283C0.434617 10.0371 0.165283 9.76782 0.165283 9.43715V1.67715C0.165283 1.34648 0.434617 1.07715 0.765283 1.07715H4.59462C4.92528 1.07715 5.19462 1.34648 5.19462 1.67715C5.19462 2.00782 4.92528 2.27715 4.59462 2.27715H1.36528V8.83448H7.87462V5.50115C7.87462 5.17048 8.14395 4.90115 8.47462 4.90115C8.80528 4.90115 9.07462 5.17048 9.07462 5.50115V9.43448C9.07728 9.76782 8.80795 10.0371 8.47728 10.0371Z' fill='currentColor' />
      <path d='M9.61065 4.20488C9.27998 4.20488 9.01065 3.93555 9.01065 3.60488V1.23955H6.59731C6.26665 1.23955 5.99731 0.970217 5.99731 0.639551C5.99731 0.308884 6.26665 0.0395508 6.59731 0.0395508H9.61065C9.94131 0.0395508 10.2106 0.308884 10.2106 0.639551V3.60755C10.2106 3.93822 9.94131 4.20488 9.61065 4.20488Z' fill='currentColor' />
      <path d='M4.93324 5.85043C4.77857 5.85043 4.62391 5.79177 4.50657 5.67177C4.27457 5.4371 4.27724 5.05577 4.51191 4.82377L9.18657 0.210432C9.42124 -0.0215678 9.80257 -0.0189013 10.0346 0.215765C10.2666 0.450432 10.2639 0.831765 10.0292 1.06377L5.35457 5.6771C5.23724 5.79443 5.08524 5.85043 4.93324 5.85043Z' fill='currentColor' />
    </svg>
  );
};
